'use client';

interface AnimatedYawlProps {
  size?: number;
  color?: string;
  secondaryColor?: string;
  duration?: number;
}

export function AnimatedYawl({ 
  size = 120, 
  color: _color,
  secondaryColor: _secondaryColor,
  duration = 4 
}: AnimatedYawlProps) {
  const sailDuration1 = duration * 1.5;
  const sailDuration2 = duration * 1.2;
  const sailDuration3 = duration * 1.3;
  
  return (
    <div
      className="text-slate-400 dark:text-slate-600 opacity-60 dark:opacity-30 relative inline-block transition-opacity animate-sailboat-float-yawl"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        animationDuration: `${duration}s`,
      }}
    >
      <svg
        viewBox="0 0 120 140"
        width="100%"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Hull - slightly longer for Yawl elegance */}
        <path
          d="M10,110 Q60,135 110,110 L100,110 L20,110 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"
        />
        
        {/* Main Mast (Front) */}
        <rect x="45" y="15" width="4" height="95" fill="currentColor" />
        
        {/* Main Sail */}
        <g
          className="animate-sail-sway-yawl"
          style={{
            animationDuration: `${sailDuration1}s`,
            transformOrigin: '47px 110px',
          }}
        >
          <path
            d="M49,20 L49,105 L85,105 Q65,50 49,20 Z"
            fill="currentColor"
            opacity="0.9"
          />
        </g>
        
        {/* Jib Sail (Front small sail) */}
        <g
          className="animate-sail-sway-yawl"
          style={{
            animationDuration: `${sailDuration2}s`,
            animationDirection: 'reverse',
            transformOrigin: '45px 110px',
          }}
        >
          <path
            d="M45,20 L45,105 L15,105 Q30,50 45,20 Z"
            fill="currentColor"
            opacity="0.8"
          />
        </g>

        {/* Mizzen Mast (Back - characteristic of Yawl) */}
        <rect x="95" y="80" width="3" height="30" fill="currentColor" />

        {/* Mizzen Sail (Small back sail) */}
        <g
          className="animate-sail-sway-yawl"
          style={{
            animationDuration: `${sailDuration3}s`,
            transformOrigin: '96.5px 110px',
          }}
        >
          <path
            d="M98,85 L98,105 L110,105 Q105,90 98,85 Z"
            fill="currentColor"
            opacity="0.85"
          />
        </g>
        
        {/* Flag on Main Mast */}
        <path
          d="M45,15 L30,20 L45,25 Z"
          fill="#FFB347"
          className="animate-sail-sway-yawl"
          style={{ animationDuration: '1s' }}
        />
      </svg>
    </div>
  );
}

